// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i5oGj","input":"styles_input__fRkg4"};